import { QueryParams } from '@/model';
import apiClient from '../api/apiClient';
import { buildApiUrl } from '../utils';
import {
  GetPredictionsByUUIDResponse,
  GetPredictionsRankingResponse,
  GetPredictionsResponse,
  GetPredictionsResultResponse,
  PostPredictionsResponse,
  PutPredictionsResponse,
} from '../response/predictions';

export class PredictionsService {
  static getPredictions(params?: QueryParams) {
    return apiClient.get<GetPredictionsResponse>(buildApiUrl('/api/v1/interactive-area/predictions'), params);
  }

  static getPredictionsByUUID(id: string) {
    const url = buildApiUrl('/api/v1/interactive-area/predictions/:id', { id });
    return apiClient.get<GetPredictionsByUUIDResponse>(url, undefined);
  }

  static getPredictionsRanking() {
    return apiClient.get<GetPredictionsRankingResponse>(
      buildApiUrl('/api/v1/interactive-area/predictions/ranking'),
      undefined,
    );
  }

  static getPredictionsResult(id: string) {
    const url = buildApiUrl('/api/v1/interactive-area/predictions/:id/result', { id });
    return apiClient.get<GetPredictionsResultResponse>(url, undefined);
  }

  static postPredictions(data: any) {
    return apiClient.createWithFile<PostPredictionsResponse>(buildApiUrl('/api/v1/interactive-area/predictions'), data);
  }

  static putPredictions(id: string, data: any) {
    const url = buildApiUrl('/api/v1/interactive-area/predictions/:id', { id });
    return apiClient.updateWithFile<PutPredictionsResponse>(url, data);
  }

  static putPredictionsResult(id: string, data: any) {
    const url = buildApiUrl('/api/v1/interactive-area/predictions/:id/result', { id });
    return apiClient.update<void>(url, data);
  }

  static putPredictionsInteractive(id: string, data: any) {
    const url = buildApiUrl('/api/v1/interactive-area/predictions/:id/interactivity', { id });
    return apiClient.update<void>(url, data);
  }

  static deletePredictions(id: string) {
    const url = buildApiUrl('/api/v1/interactive-area/predictions/:id', { id });
    return apiClient.delete<void>(url);
  }
}
